import { jsx as _jsx } from "react/jsx-runtime";
import { ProductTileClickImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React from "react";
export var ProductTileImpressionProvider = function(param) {
    var children = param.children, productBasedCollectionToken = param.productBasedCollectionToken, requestId = param.requestId;
    var contextToken = productBasedCollectionToken !== null && productBasedCollectionToken !== void 0 ? productBasedCollectionToken : "";
    var context = "".concat(ProductTileContainer.PRODUCT_BASED_COLLECTION_LIST, "|").concat(contextToken);
    return /*#__PURE__*/ _jsx(ProductTileViewImpressionProvider, {
        context: context,
        screenContext: ProductTileScreen.PRODUCT_BASED_COLLECTION,
        containerContext: ProductTileScreenContainer.PRODUCT_BASED_COLLECTION_PRODUCTS,
        contextToken: contextToken,
        requestId: requestId,
        children: /*#__PURE__*/ _jsx(ProductTileClickImpressionProvider, {
            context: context,
            productTileContainer: ProductTileContainer.PRODUCT_BASED_COLLECTION_LIST,
            screenContext: ProductTileScreen.PRODUCT_BASED_COLLECTION,
            containerContext: ProductTileScreenContainer.PRODUCT_BASED_COLLECTION_PRODUCTS,
            contextToken: contextToken,
            requestId: requestId,
            children: children
        })
    });
};
